import api from './api';
import interceptors from './interceptors';

export {
    api,
    interceptors,
};
